"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getCookie: function() {
        return getCookie;
    },
    setCookie: function() {
        return setCookie;
    }
});
var _sliced_to_array = require("@swc/helpers/_/_sliced_to_array");
var getCookie = function(cookieName) {
    var matches = document.cookie.match(new RegExp("(?:^|;|,) ?".concat(cookieName, "=([^;,]*)(?:;|,|$)")));
    return matches ? matches[1] : undefined;
};
var setCookie = function(param) {
    var name = param.name, value = param.value, exdays = param.exdays, _param_path = param.path, path = _param_path === void 0 ? "/" : _param_path, domain = param.domain;
    if (typeof name !== "string" && !name) {
        return null;
    }
    if (typeof window === "undefined") {
        return null;
    }
    var currentValueIfExists = getCookie(name);
    if (currentValueIfExists) {
        return currentValueIfExists;
    }
    var hasExpirationDays = Number.isInteger(exdays);
    var currentDate = new Date();
    var _window_location_hostname_split_reverse = _sliced_to_array._(window.location.hostname.split(".").reverse(), 2), extension = _window_location_hostname_split_reverse[0], domainName = _window_location_hostname_split_reverse[1];
    if (hasExpirationDays) {
        currentDate.setTime(currentDate.getTime() + exdays * 24 * 60 * 60 * 1000);
    }
    var expirationDate = hasExpirationDays ? ";expires=".concat(currentDate.toUTCString()) : "";
    var currentPath = path ? ";path=".concat(path) : "";
    var currentDomain = ";domain=".concat(domain || "".concat(domainName, ".").concat(extension));
    document.cookie = "".concat(name, "=").concat(value).concat(expirationDate).concat(currentPath).concat(currentDomain);
    return value;
};

//# sourceMappingURL=cookie.js.map